import { render, staticRenderFns } from "./ArrivalMask.vue?vue&type=template&id=d5ef0252&scoped=true&"
import script from "./ArrivalMask.vue?vue&type=script&lang=js&"
export * from "./ArrivalMask.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalMask.vue?vue&type=style&index=0&id=d5ef0252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ef0252",
  null
  
)

export default component.exports